'use strict';

const leavingSiteText = 'You are about to leave ThisisPNH.com to visit a third-party website. We recommend reviewing the privacy policy and terms and conditions of any site you visit, as we are not responsible for their content.';
const apellisText = 'You are now leaving ThisisPNH.com. This link will take you to another Apellis Pharmaceuticals, Inc. website.';

document.addEventListener( 'DOMContentLoaded', () => {
	let { links } = document;
	links = Array.prototype.slice.call( links );

	links.forEach( ( link ) => {
		if (
			link.hostname === 'apellis.com'
			|| link.hostname === 'apellisrsvp.com'
			|| link.hostname === 'www.apellisrsvp.com'
			|| link.hostname === 'www.empaveli.com'
			|| link.hostname === 'empaveli.com'
			|| link.hostname === 'pnhtreatmentoption.com'
			|| link.hostname === 'www.pnhtreatmentoption.com'
			|| link.hostname === 'www.PNHtreatmentoption.com'
			|| link.hostname === 'PNHtreatmentoption.com'
		) {
			// eslint-disable-next-line no-param-reassign
			link.target = '_blank';
			link.setAttribute( 'rel', 'noopener' );
			link.setAttribute( 'data-external-link', true );
			link.setAttribute( 'data-apellis-link', true );
		} else if ( link.hostname !== window.location.hostname && ! link.href.includes( 'mailto:' ) ) {
			// eslint-disable-next-line no-param-reassign
			link.target = '_blank';
			link.setAttribute( 'rel', 'noopener' );
			link.setAttribute( 'data-external-link', true );
			link.setAttribute( 'data-micromodal-trigger', 'leaving-site-modal' );
		} else if ( link.href.substr( link.href.length - 4 ) === '.pdf' ) {
			link.target = '_blank';
		}
	} );

	const externalLinks = document.querySelectorAll( '[data-external-link]' );
	const continueToSite = document.querySelectorAll( '#continue-to-site' );

	externalLinks.forEach( ( externalLink ) => {
		const externalLinkNotification = document.createElement( 'span' );
		externalLinkNotification.classList.add( 'clip' );
		externalLinkNotification.innerHTML = ' (opens in new tab)';
		externalLink.appendChild( externalLinkNotification );
		externalLink.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			const linkDestination = externalLink.getAttribute( 'href' );
			continueToSite.forEach( button => {
				button.target = '_blank';
				button.setAttribute( 'href', linkDestination );
			} )
			const leavingSiteModalText = document.querySelector( '#leaving-site-modal-content p' );
			const modalContainer = document.querySelector( '#leaving-site-modal .modal__container' );
			if ( externalLink.getAttribute( 'data-apellis-link' ) ) {
				leavingSiteModalText.innerText = apellisText;
				modalContainer.setAttribute( 'data-apellis-site', true );
			} else {
				leavingSiteModalText.innerText = leavingSiteText;
				modalContainer.setAttribute( 'data-apellis-site', false );
			}
			MicroModal.show( 'leaving-site-modal' );
		} );
	} );

	const closeModal = document.getElementById( 'close-modal' );

	closeModal.addEventListener( 'click', () => {
		MicroModal.close( 'leaving-site-modal' );
		const singleEventModal = document.getElementById( 'single-event-modal' )
		if ( singleEventModal ) {
			MicroModal.close( 'single-event-modal' );
			const modalContent = document.querySelector( '#single-event-modal [data-past-event-modal-content]' );
			if ( modalContent ) modalContent.innerHTML = '';
		}
	} );

	continueToSite.forEach( button => button.addEventListener( 'click', () => MicroModal.close( 'leaving-site-modal' ) ) )

} );
